import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["style", "width", "height", "tagName"],
  _excluded2 = ["className"],
  _excluded3 = ["className", "diameter"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import { useBreakpoints } from '@carnica/utils/hooks';
import styles from "./styles.pcss";
import { getSize } from "./utils";
var cnSkeletonBrick = cnBem('skeleton-brick', styles);
var cnSkeletonCircle = cnBem('skeleton-circle', styles);
var Skeleton = forwardRefWithTag(function (_ref, ref) {
  var _objectSpread2;
  var style = _ref.style,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? '100%' : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 16 : _ref$height,
    _ref$tagName = _ref.tagName,
    tagName = _ref$tagName === void 0 ? 'span' : _ref$tagName,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useBreakpoints = useBreakpoints(),
    _useBreakpoints2 = _slicedToArray(_useBreakpoints, 1),
    breakpoint = _useBreakpoints2[0];
  var dimension = breakpoint || 'desktop';
  var Tag = tagName;
  return /*#__PURE__*/React.createElement(Tag, _extends({}, props, {
    ref: ref,
    style: _objectSpread((_objectSpread2 = {}, _defineProperty(_objectSpread2, '--skeleton-width', getSize(width, dimension)), _defineProperty(_objectSpread2, '--skeleton-height', getSize(height, dimension)), _objectSpread2), style)
  }));
});
export var SkeletonBrick = forwardRefWithTag(function (_ref2, ref) {
  var className = _ref2.className,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Skeleton, _extends({
    className: cnSkeletonBrick(null, [className]),
    ref: ref
  }, props));
});
export var SkeletonCircle = forwardRefWithTag(function (_ref3, ref) {
  var className = _ref3.className,
    _ref3$diameter = _ref3.diameter,
    diameter = _ref3$diameter === void 0 ? 32 : _ref3$diameter,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(Skeleton, _extends({
    className: cnSkeletonCircle(null, [className]),
    height: diameter,
    ref: ref,
    width: diameter
  }, props));
});